/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Box, Flex, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { useMemo } from 'react';
import { gql, useMutation } from '@apollo/client';
import RichTextEditorField from '../../../components/form/RichTextEditorField';
import RadioValueFormField from '../../../components/form/RadioValueFormField';
import ProposalLinkableInputField from '../../../components/form/ProposalLinkableInputField';
import c from '../../../constant';
import * as Yup from 'yup';

const M_CREATE = gql`
	mutation create($type: NpEnumType!, $subject: String!, $proposalNumber: Float) {
		createNewDraft(type: $type, subject: $subject, proposalNumber: $proposalNumber) {
			id
			type
		}
	}
`;

function Create({ onClose = () => null, onComplete = () => null, proposalNumberLink = '' }) {
	const toast = useToast();
	const { t } = useTranslation();
	const [createRecord, { loading }] = useMutation(M_CREATE);

	const validationSchema = useMemo(
		() =>
			Yup.object().shape({
				type: Yup.string().required('required'),
				subject: Yup.string().required('required'),
				proposal: Yup.mixed().test('valid', 'invalid', (value) => {
					if (value?.proposalNumber) {
						if (value?.proposal) {
							return true;
						} else {
							return false;
						}
					} else {
						return true;
					}
				}),
			}),
		[]
	);

	return (
		<Modal size="2xl" closeOnEsc={!loading} closeOnOverlayClick={!loading} isOpen={true} onClose={onClose}>
			<ModalOverlay />
			<ModalContent borderRadius={c.borderRadius}>
				<ModalHeader pb={0} mb={0}>
					{t('Create a new np or rp')}
				</ModalHeader>
				<ModalCloseButton isDisabled={loading} />
				<ModalBody>
					<Formik
						initialValues={{ type: '', subject: '', proposal: { proposalNumber: proposalNumberLink || '', proposal: null } }}
						validationSchema={validationSchema}
						onSubmit={(values) => {
							const type = values?.type;
							const subject = values?.subject;
							const proposalNumber = values?.proposal?.proposal?.no;
							const variables = { type, subject, proposalNumber };
							createRecord({ variables })
								.then(({ data }) => {
									onClose();
									onComplete(data?.createNewDraft);
								})
								.catch((error) => {
									if (error?.graphQLErrors?.length > 0) {
										error?.graphQLErrors.map(({ message }, i) =>
											toast({
												title: t(message),
												status: 'error',
												isClosable: true,
												position: 'bottom-right',
											})
										);
									} else {
										toast({
											title: t(error?.message ? error?.message : 'something went wrong'),
											status: 'error',
											isClosable: true,
											position: 'bottom-right',
										});
									}
								});
						}}
					>
						{({ values }) => (
							<Form>
								<Box mt="2">
									<>
										<RadioValueFormField
											name="type"
											label="type"
											disabled={loading}
											required={true}
											radios={[
												{ label: 'Note of Presentation', value: 'NoteOfPresentation' },
												{ label: 'Report', value: 'Report' },
											]}
										/>
									</>
									{values?.type && (
										<>
											<RichTextEditorField name="subject" label="Subject" disabled={loading} showToolbar={true} required={true} />
											<ProposalLinkableInputField
												name="proposal"
												label="Proposal Number"
												type="number"
												disabled={loading}
												required={false}
											/>
										</>
									)}
									<>
										<Flex flex="1" mt={4} mb={2} justifyContent="flex-end" alignItems="center">
											<Button type="submit" isLoading={loading} borderRadius={c.borderRadius} colorScheme="blue" onMouseDown={() => null}>
												{t('Create')}
											</Button>
										</Flex>
									</>
								</Box>
							</Form>
						)}
					</Formik>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default Create;
